import React from 'react';
import CourseProgressWidget from './dashboard/CourseProgressWidget';
import CommunityActivityWidget from './dashboard/CommunityActivityWidget';
import AISuggestionsWidget from './dashboard/AISuggestionsWidget';
import UpcomingEventsWidget from './dashboard/UpcomingEventsWidget';
import StatsWidget from './dashboard/StatsWidget';
const Dashboard = () => {
  return <div className="space-y-4" data-id="element-1131">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1132">
        <div className="col-span-1 md:col-span-2" data-id="element-1133">
          <CourseProgressWidget data-id="element-1134" />
          <div className="mt-4" data-id="element-1135">
            <StatsWidget data-id="element-1136" />
          </div>
          <div className="mt-4" data-id="element-1137">
            <UpcomingEventsWidget data-id="element-1138" />
          </div>
        </div>
        <div className="col-span-1" data-id="element-1139">
          <AISuggestionsWidget data-id="element-1140" />
        </div>
      </div>
    </div>;
};
export default Dashboard;